﻿import { Widget } from "blue-widgets";

class NotificationBar extends Widget {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.dismissButton = this.el.querySelector("[data-dismiss]");
        this.culture = this.el.getAttribute("data-culture");

        this.el.classList.add("isVisible");

        if (this.dismissButton) {
            this.dismissButton.addEventListener("click", async () => {
                await fetch("/umbraco/Surface/NotificationBarSurface/CloseBanner", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        culture: this.culture
                    })
                })
                    .then((response) => {
                        if (response.ok) {
                            this.el.classList.remove("isVisible");

                        } else {
                            console.error("Error sending POST request. Status:", response.status);
                        }
                    })
                    .catch((error) => {
                        console.error("Error sending POST request:", error);
                    });
            });
        }
    }
}

export default NotificationBar;